/// HOOKS ///
import { useNavigate } from "react-router-dom";
import useQuoteTotals from "hooks/quote/totals";
/// FM ///
import { motion } from "framer-motion";
/// TIME ///
import { DateTime } from "luxon";
/// MUI COMPONENTS ///
import { Grid } from "@mui/material";
import { Typography } from "@mui/material";
/// TYPES ///
import { Order } from "api/types/order";
import { QuoteTotals } from "api/types/quote";
/// URLS ///
import { shop_url } from "components/navigation/endpoints";
import { order_url } from "components/navigation/endpoints";
/// STYLES ///
import { row_btn_style } from "styles/universal/row";
import { row_text_item_style } from "styles/universal/row";
/// MOTION ///
import { row_text_motion } from "styles/universal/row";

interface Props {
  item: Order
}

export default function ShopOrderItem({ item }: Props) {
  const navigate = useNavigate();
  const totals: QuoteTotals = useQuoteTotals(item);

  return (
    <Grid item xs={12}>
      <motion.button
        initial="rest"
        whileHover="hover"
        animate="rest"
        variants={row_text_motion}
        onClick={() => navigate(`/${shop_url}/${order_url}/${item.id}`)}
        style={row_btn_style}>
        <Grid container>
          <Grid item xs={2.5}>
            <Typography variant="body2" align="left" noWrap sx={row_text_item_style}>
              {DateTime.fromISO(item.created).toLocal().toFormat("LLLL dd, yyyy")}
            </Typography>
          </Grid>
          <Grid item xs={3}>
            <Typography variant="body2" align="left" noWrap sx={row_text_item_style}>
              {item.name}
            </Typography>
          </Grid>
          <Grid item xs={3.5}>
            <Typography variant="body2" align="left" noWrap sx={row_text_item_style}>
              {item?.end_customer_data?.is_business ? item?.end_customer_data?.business_name : `${item?.end_customer_data?.first_name ?? ""} ${item?.end_customer_data?.last_name ?? ""}`}
            </Typography>
          </Grid>
          <Grid item xs={3}>
            <Typography variant="body2" align="left" noWrap sx={row_text_item_style}>
              ${(totals.subtotal - totals.discount + totals.tax1 + totals.tax2).toFixed(2)}
            </Typography>
          </Grid>
        </Grid>
      </motion.button>
    </Grid>
  )
}
